import { render, staticRenderFns } from "./BankAccountAddress2.vue?vue&type=template&id=965b212c&scoped=true"
import script from "./BankAccountAddress2.vue?vue&type=script&lang=js"
export * from "./BankAccountAddress2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965b212c",
  null
  
)

export default component.exports